import { Breadcrumbs as QuantumBreadcrumbs, BreadcrumbsItem as QuantumBreadcrumbsItem } from '@a0/quantum-product';
import * as React from 'react';
import { useFluxible } from '../hooks/useFluxible';
import { NavLink } from '../NavLink';
export var Breadcrumbs = function (_a) {
    var crumbs = _a.crumbs;
    var context = useFluxible();
    return (React.createElement(QuantumBreadcrumbs, { itemScope: true, itemType: "http://schema.org/BreadcrumbList" }, crumbs.map(function (crumb, index) { return (React.createElement("span", { itemProp: "itemListElement", itemScope: true, itemType: "http://schema.org/ListItem", key: crumb.title + crumb.url, onClick: function () { return context.trackEvent('click:breadcrumb', { title: crumb.title, url: crumb.url }); } },
        React.createElement(NavLink, { itemProp: "item", href: crumb.url, followLink: crumb.forceFullReload },
            React.createElement(QuantumBreadcrumbsItem, { itemProp: "name", component: "button", label: crumb.title })),
        React.createElement("meta", { itemProp: "position", content: (index + 1).toString() }))); })));
};
